import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31cc66d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text__text_container" }
const _hoisted_2 = {
  key: 0,
  class: "text__title title--large"
}
const _hoisted_3 = {
  key: 1,
  class: "text__title title"
}
const _hoisted_4 = {
  key: 2,
  class: "text__title title--small"
}
const _hoisted_5 = {
  key: 3,
  class: "text__introduction"
}
const _hoisted_6 = {
  key: 4,
  class: "text__text"
}
const _hoisted_7 = { class: "text__button" }
const _hoisted_8 = { class: "text__with_subject__subject_container" }
const _hoisted_9 = { class: "text__with_subject__subject" }
const _hoisted_10 = { class: "text__with_subject__text" }
const _hoisted_11 = {
  key: 0,
  class: "text__image_container"
}
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _component_page_section = _resolveComponent("page-section")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createBlock(_component_page_section, {
    class: _normalizeClass(["text", [
      { 'text--with-image': _ctx.image },
      _ctx.imagePosition ? `text--with-image--${_ctx.imagePosition}` : '',
    ]]),
    backgroundColor: _ctx.backgroundColor || null,
    revealOnScroll: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textElements, (textElement, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `textelement-${index}`
          }, [
            (textElement.type == 'title_large')
              ? _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_2, null, 512)), [
                  [_directive_sanitize, textElement.text]
                ])
              : _createCommentVNode("", true),
            (textElement.type == 'title')
              ? _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_3, null, 512)), [
                  [_directive_sanitize, textElement.text]
                ])
              : _createCommentVNode("", true),
            (textElement.type == 'title_small')
              ? _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_4, null, 512)), [
                  [_directive_sanitize, textElement.text]
                ])
              : _createCommentVNode("", true),
            (textElement.type == 'introduction')
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, null, 512)), [
                  [_directive_sanitize, textElement.text]
                ])
              : _createCommentVNode("", true),
            (textElement.type == 'paragraph')
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, null, 512)), [
                  [_directive_sanitize, textElement.text]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (textElement.type == 'link')
                ? (_openBlock(), _createBlock(_component_ButtonLink, {
                    key: 0,
                    label: textElement.link.title,
                    href: textElement.link.url,
                    target: textElement.link.target,
                    color: 
              _ctx.backgroundColor && _ctx.backgroundColor === 'black' ? 'yellow' : null
            
                  }, null, 8, ["label", "href", "target", "color"]))
                : _createCommentVNode("", true)
            ]),
            (textElement.type == 'paragraph_with_subject')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(textElement.groups, (group, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "text__with_subject",
                    key: `textgroup-${index}`
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [
                        [_directive_sanitize, group.subject]
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
                      [_directive_sanitize, group.text]
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("img", { src: _ctx.image }, null, 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["backgroundColor", "class"]))
}